<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> مدیریت کسب و کارها </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-md-0 gy-3" [formGroup]="mdl_Search">

        <!-- استان -->
        
        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> استان </label>

            <select class="form-select p-2" formControlName="strState" (change)="getCity($event.target.value)">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_State" [value]="item.strState">

                    {{item.strStateName}}

                </option>

            </select>

        </div>

        <!-- شهر -->
        
        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> شهر </label>

            <select class="form-select p-2" formControlName="strCityCode">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_City" [value]="item.strCity">

                    {{item.strCityName}}

                </option>

            </select>

        </div>
        
        <!-- گروه -->
        
        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> گروه </label>

            <select class="form-select p-2" formControlName="iResume_Category" (change)="getSubGroup($event.target.value)">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Group" [value]="item.iResume_Category">

                    {{item.strComment}}

                </option>

            </select>

        </div>
        
        <!-- زیر گروه -->
        
        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> زیر گروه </label>

            <select class="form-select p-2" formControlName="iResume_SubCategory">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_SubGroup" [value]="item.iResume_SubCategory">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- منتشر شده -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-6 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bPublish" formControlName="bPublish">
        
            <label class="form-check-label pointer text-muted me-2" for="bPublish"> منتشر شده </label>
        
        </div>

        <!-- نردبان -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-6 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bVIP" formControlName="bVIP">
        
            <label class="form-check-label pointer text-muted me-2" for="bVIP"> نردبان </label>
        
        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-primary w-100" (click)="getResult()"> 

                &nbsp; جستجو &nbsp;
                
            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-2 gy-md-0 gy-3">

            <!-- اینپوت جستجو -->

            <div class="col-12 col-md-11">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <!-- افزودن -->

            <div class="col-12 col-md-auto">

                <button class="btn btn-success w-100" (click)="add_Business()"> 

                    افزودن
                    
                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 220px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="">
        
                        <th class="text-center"> # </th>
    
                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> کد کسب و کار </th>

                        <th class="text-center"> عنوان </th>

                        <th class="text-center"> تاریخ ثبت </th>

                        <th class="text-center"> تاریخ اعتبار </th>

                        <th class="text-center"> استان </th>

                        <th class="text-center"> شهر </th>

                        <th class="text-center"> زیر گروه </th>

                        <th class="text-center"> وضعیت </th>

                        <th class="text-center"> نردبان </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Result;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class=""> 

                            <i class="fa fa-eye fa-lg pointer" aria-hidden="true" (click)="add_Business('View',item)"></i>

                            <i class="fa fa-pencil-square mx-2 fa-lg pointer" aria-hidden="true" (click)="add_Business('Edit',item)"></i>

                            <i class="fa fa-trash fa-lg pointer" aria-hidden="true" (click)="remove_Business(item,i)"></i>

                            <i class="fa fa-map-marker mx-2 fa-lg pointer" aria-hidden="true" (click)="open_Location(item)"></i>
                            
                        </th>

                        <td>{{item.iTaxiLon_User | faNum }}</td>

                        <td>{{item.strTitle | faNum}}</td>

                        <td>{{item.strSaveDate | faNum}}</td>

                        <td>{{item.strValidityDate.trim() | faNum}}</td>

                        <td>{{item.strStateName | faNum}}</td>

                        <td>{{item.strCityName | faNum}}</td>

                        <td>{{item.strResume_SubCategory_strComment | faNum}}</td>

                        <td>{{item.strPublish | faNum}}</td>

                        <td>{{item.strVIP | faNum}}</td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <!-- مدال افزودن, ویرایش, مشاهده -->

    <div class="modal fade" id="Add_Business" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog modal-lg">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel"> {{ modal_Title }} </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- شماره موبایل -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> شماره موبایل </label>
                
                            <input class="form-control p-2 text-center" #strMobile

                                (paste)="handlePaste($event)"

                                (blur)="tempStrMobile != strMobile.value ? checkMobile() : '' "

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                                maxlength="11"  formControlName="strMobile">
                
                        </div>

                        <!-- عنوان -->

                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> عنوان </label>
                
                            <input class="form-control p-2 text-center" formControlName="strTitle">
                
                        </div>

                        <!-- استان -->
        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> استان </label>

                            <select class="form-select p-2" formControlName="strState" (change)="getCity($event.target.value)">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_State" [value]="item.strState">

                                    {{item.strStateName}}

                                </option>

                            </select>

                        </div>

                        <!-- شهر -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> شهر </label>

                            <select class="form-select p-2" formControlName="strCityCode">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_City" [value]="item.strCity">

                                    {{item.strCityName}}

                                </option>

                            </select>

                        </div>
                        
                        <!-- گروه -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> گروه </label>

                            <select class="form-select p-2" formControlName="iResume_Category" (change)="getSubGroup($event.target.value)">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Group" [value]="item.iResume_Category">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>
                        
                        <!-- زیر گروه -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> زیر گروه </label>

                            <select class="form-select p-2" formControlName="iResume_SubCategory">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_SubGroup" [value]="item.iResume_SubCategory">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>
                        
                        <!-- تلفن -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> تلفن </label>
                
                            <input class="form-control p-2 text-center"

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                                maxlength="11"
                            
                                formControlName="strTel">
                
                        </div>
                        
                        <!-- روزهای فعالیت -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> روزهای فعالیت </label>
                
                            <input class="form-control p-2 text-center" formControlName="strWeekDays">
                
                        </div>
                        
                        <!-- ساعت کاری -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> ساعت کاری </label>
                
                            <input class="form-control p-2 text-center" formControlName="strHoursOperation">
                
                        </div>

                        <!-- تاریخ اعتبار -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> تاریخ اعتبار </label>
                
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                
                                <input formControlName="strValidityDate" class="form-control text-end" />
                
                            </ng-persian-datepicker>
                
                        </div>

                        <!-- ایمیل -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> ایمیل </label>
                
                            <input class="form-control p-2 text-end" formControlName="strEmail">
                
                        </div>

                        <!-- تلگرام -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> تلگرام </label>
                
                            <input class="form-control p-2 text-end" formControlName="strTelegram">
                
                        </div>

                        <!-- واتساپ -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> واتساپ </label>
                
                            <input class="form-control p-2 text-end" formControlName="strWhatsUp">
                
                        </div>

                        <!-- فیس بوک -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> فیس بوک </label>
                
                            <input class="form-control p-2 text-end" formControlName="strFacebook">
                
                        </div>

                        <!-- اینستاگرام -->
                        
                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="mb-2 text-muted"> اینستاگرام </label>
                
                            <input class="form-control p-2 text-end" formControlName="strInstagram">
                
                        </div>

                        <!-- وبسایت -->
                        
                        <div class="position-relative col-12 col-md-8 p-2">

                            <label class="mb-2 text-muted"> وبسایت </label>
                
                            <input class="form-control p-2 text-end" formControlName="strWebsite">
                
                        </div>

                        <!-- آدرس -->

                        <div class="position-relative col-12 p-2">
                
                            <label class="mb-2 text-muted"> آدرس </label>

                            <custom-map *ngIf="showCustom_Map && !showCustom_Map2"

                                [strValue]="mdl_Request.get('strAddress')?.value"

                                [longLat]="[mdl_Request.get('fLon')?.value,mdl_Request.get('fLat')?.value]"
                            
                                [stylesArray]="['padding-top: 10px']"

                                [isDisabled]="mdl_Request.disabled ? true : false"

                                [isTextArea]="false"

                                [isLocationBtn]="mdl_Request.disabled ? false : true"
                            
                                [str_Placeholder]="'آدرس خود را جستجو کنید ...'"
                                
                                (mdl_Submit)="submitData($event)">

                            </custom-map>
                            
                        </div>

                        <!-- انتشار -->

                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bPublish" formControlName="bPublish">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bPublish"> انتشار </label>
                        
                        </div>

                        <!-- معتبر -->

                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bValid" formControlName="bValid">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bValid"> معتبر </label>
                        
                        </div>

                        <!-- ویژه -->

                        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

                            <input class="form-check-input m-0" type="checkbox" id="bVIP" formControlName="bVIP">
                        
                            <label class="form-check-label pointer text-muted me-2" for="bVIP"> ویژه </label>
                        
                        </div>

                        <!-- توضیحات -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> توضیحات </label>

                            <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strCV"></textarea>

                        </div>

                        <!-- لیست نمونه کارها -->

                        <div class="position-relative col-12 p-2">

                            <div class="accordion" id="accordionPanelsStayOpenExample">

                                <!-- لیست نمونه کار ها -->

                                <div class="accordion-item">

                                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">

                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" disabled>

                                        لیست نمونه کار ها

                                    </button>

                                  </h2>

                                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">

                                    <div class="accordion-body">

                                        <div class="container-fluid row gx-2 gy-2">

                                            <!-- لیست نمونه کارها -->

                                            <ng-container *ngFor="let item of lst_Resume;let i = index">

                                                <div class="col-12 col-md-4 p-1">

                                                    <div class="resume-box w-100 p-1 border border-2 rounded">
                                                        
                                                        <img src="{{'data:image/jpeg;base64,'+ item.strImage}}" loading="lazy" alt="نمونه کار">

                                                        <div class="row gx-0 gy-0 p-2">

                                                            <ng-container *ngIf="mdl_Request.disabled;else isEditable">

                                                                <div class="col-12">

                                                                    <p> {{ item.strComment }} </p>

                                                                </div>

                                                            </ng-container>

                                                            <ng-template #isEditable>

                                                                <!-- ویرایش -->
    
                                                                <div class="col-6 px-1">
    
                                                                    <button class="w-100 btn btn-outline-primary" (click)="edit_Resume(item,i)">
            
                                                                        <i class="fa fa-pencil-square fa-lg pointer"></i>
            
                                                                    </button>
    
                                                                </div>
    
                                                                <!-- حذف -->
    
                                                                <div class="col-6 px-1">
                                                                    
                                                                    <button class="w-100 btn btn-outline-danger" (click)="remove_Resume(item,i)">
            
                                                                        <i class="fa fa-trash fa-lg pointer"></i>
            
                                                                    </button>
    
                                                                </div>

                                                            </ng-template>

                                                        </div>

                                                    </div>

                                                </div>

                                            </ng-container>

                                            <!-- افزودن نمونه کار -->

                                            <ng-container *ngIf="!mdl_Request.disabled">

                                                <div class="text-end">
    
                                                    <button class="btn btn-outline-secondary" [disabled]="mdl_Request.get('iTaxiLon_User')?.value == ''" (click)="add_Resume()"> 
    
                                                        افزودن نمونه کار
                                                        
                                                    </button>
    
                                                </div>

                                            </ng-container>

                                        </div>

                                    </div>

                                  </div>

                                </div>

                                <!-- لیست تخصص ها -->

                                <div class="accordion-item">

                                  <h2 class="accordion-header" id="panelsStayOpen-headingTwo">

                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true" disabled>

                                        لیست تخصص ها
                                   
                                    </button>

                                  </h2>

                                  <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingTwo">

                                    <div class="accordion-body">

                                        <div class="container-fluid row gx-2 gy-2">

                                            <!-- لیست تخصص ها -->

                                            <ng-container *ngFor="let item of lst_Expertise;let i = index">

                                                <div class="col-12 p-1">

                                                    <p class="mb-1"> دسته بندی : 
                                                        
                                                        <b> {{item.strResume_Category_strComment}}, {{item.strResume_SubCategory_strComment}} </b>
                                                    
                                                    </p>

                                                    <p class="mb-0" style="word-break: break-all;">
                                                        
                                                        توضیحات : {{ item.strComment || 'ندارد' }} 
                                                    
                                                    </p>
                                                    
                                                </div>

                                                <ng-container *ngIf="!mdl_Request.disabled">

                                                    <div class="col-12 p-1 text-end">

                                                        <button class="btn btn-outline-danger" (click)="remove_Expertise(item,i)">
            
                                                            <i class="fa fa-trash fa-lg pointer"></i>

                                                        </button>

                                                    </div>

                                                </ng-container>

                                                <hr>

                                            </ng-container>

                                            <!-- افزودن تخصص  -->

                                            <ng-container *ngIf="!mdl_Request.disabled">

                                                <div class="text-end">
    
                                                    <button class="btn btn-outline-secondary" [disabled]="mdl_Request.get('iTaxiLon_User')?.value == ''" (click)="add_Expertise()"> 
    
                                                        افزودن تخصص
                                                        
                                                    </button>
    
                                                </div>

                                            </ng-container>

                                        </div>
                                  
                                    </div>

                                  </div>

                                </div>

                            </div>

                        </div>

                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">

                    <ng-container *ngIf="!mdl_Request.disabled">

                        <button [ngClass]="editMode ? 'btn-primary' : 'btn-success'" class="btn" (click)="submit_Request()">
        
                            &nbsp; {{ editMode ? 'ویرایش' : 'ثبت' }} &nbsp;
        
                        </button>

                    </ng-container>
    
                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- نمایش موقعیت کسب و کار -->

    <custom-map *ngIf="showCustom_Map2"

        [strValue]="mdl_Request.get('strAddress')?.value"

        [longLat]="[mdl_Request.get('fLon')?.value,mdl_Request.get('fLat')?.value]"

        [isOpenModal]="true"

        [isView]="true"

        [skip_Search]="true"

        (mdl_Submit)="showCustom_Map2=false">

    </custom-map>

    <!-- افزودن نمونه کار -->

    <div class="modal fade" id="Add_Resume" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel">  نمونه کار </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <div [formGroup]="mdl_Resume" class="row gx-0 gy-2">

                        <div class="uploader-container pointer col-12 p-2">

                            <img src="../../../assets/Img/outbox.png" loading="lazy" alt="آپلود تصویر" (click)="fileInput.click()">

                            <p class="my-2"> تصویر خود را آپلود کنید </p>

                            <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0]);" />

                        </div>

                        <div *ngIf="mdl_Resume.get('strImage')?.value != ''" class="preview-upload col-12">

                            <img src="{{'data:image/jpeg;base64,'+ mdl_Resume.get('strImage')?.value}}" loading="lazy" alt="تصویر آپلود شده">

                        </div>

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> توضیحات </label>
                
                            <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strComment"></textarea>
                
                        </div>

                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">
    
                    <button [ngClass]="mdl_Resume.get('bEdit')?.value ? ' btn-primary' : ' btn-success'" class="btn" (click)="submit_Resume()">
    
                        &nbsp; {{ mdl_Resume.get('bEdit')?.value  ? 'ویرایش' : 'ثبت' }} &nbsp;
    
                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

    <!-- افزودن تخصص -->

    <div class="modal fade" id="Add_Expertise" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

        <div class="modal-dialog mod">
    
            <div class="modal-content dirI">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title" id="exampleModalLabel">  تخصص </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div class="modal-body">

                    <div [formGroup]="mdl_Expertise" class="row gx-0 gy-2">
                        
                        <!-- گروه -->
                        
                        <div class="col-12 col-md-6 position-relative p-1">

                            <label class="mb-2 text-muted"> گروه </label>

                            <select class="form-select p-2" formControlName="iResume_Category" (change)="getSubGroup($event.target.value)">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Group" [value]="item.iResume_Category">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>
                        
                        <!-- زیر گروه -->
                        
                        <div class="col-12 col-md-6 position-relative p-1">

                            <label class="mb-2 text-muted"> زیر گروه </label>

                            <select class="form-select p-2" formControlName="iResume_SubCategory">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_SubGroup" [value]="item.iResume_SubCategory">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- توضیحات -->

                        <div class="position-relative col-12 p-1">

                            <label class="mb-2 text-muted"> توضیحات </label>
                
                            <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strComment"></textarea>
                
                        </div>

                    </div>
    
                </div>
    
                <div class="modal-footer d-flex justify-content-start">
    
                    <button class="btn btn-success" (click)="submit_Expertise()">
    
                        &nbsp; ثبت  &nbsp;
    
                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>
    
            </div>
    
        </div>
    
    </div>


</main>
